var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcceptWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.3 10.724L1.843 8.247c-.313-.292-.313-.766.001-1.058l6.171-5.913C8.329.984 8.328.51 8.014.22c-.315-.292-.824-.292-1.138 0L.706 6.133c-.941.874-.941 2.298 0 3.172L3.16 11.78c.157.147.363.22.57.22.205 0 .41-.073.568-.219.314-.291.315-.765 0-1.057z",
    transform: "translate(-1089.000000, -152.000000) translate(1040.000000, 0.000000) translate(40.000000, 143.000000) translate(9.000000, 9.000000) translate(9.750000, 8.625000) scale(1, -1) rotate(90.000000) translate(-9.750000, -8.625000) translate(5.625000, 2.625000)"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptWhite);
export default __webpack_public_path__ + "static/media/accept-white.8c410c12021e1d4fdf32496e00a9259c.svg";
export { ForwardRef as ReactComponent };